export default {
  会员免费: 'VIP Users Use for Free',
}
